import { ClasseProfit } from '../dila/typeadressetempost/classeprofit/ClasseProfit';

export class TypeAdresseTEMPOST  {

	ville: string;
	adr4: string;
	adr3: string;
	classeProfit: ClasseProfit;
	cp: string;
	siret: string;
	adr2: string;
	denomination: string;
	adr1: string;
	pays: string;
	tvaIntracommunautaire: string;
}
